import { reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { useNotif } from '@orion.ui/orion';
import OrganizationApi from '@/api/OrganizationApi';
import OrganizationFusionRequestApi from '@/api/OrganizationFusionRequestApi';

type Props = SetupProps<typeof OrganizationFusionRequestModalSetupService.props>

export default class OrganizationFusionRequestModalSetupService extends BaseSetupService<Props> {
	static readonly props = {};

	readonly _cleanSearch = ref<OrionInput>();
	readonly organizationMailSuffix = '@myarmado.fr';

	private _modal?: OrionModal;
	private readonly state = reactive({
		search: undefined as Undef<string>,
		selectedSearchedOrganization: undefined as Undef<ISearchResultOrganizationModel>,
		noResultForSearch: false,
	});

	get search () { return this.state.search; }
	get selectedSearchedOrganization () { return this.state.selectedSearchedOrganization; }
	get noResultForSearch () { return this.state.noResultForSearch; }

	get cleanSearch () {
		return this.state.search;
	}

	set cleanSearch (val) {
		if (val) {
			this.state.search = val?.replace(/@.*$/, '').replace(/myarmado.fr$/, '');
			const inputEl = this._cleanSearch.value?._el()?.getElementsByTagName('input')?.[0];
			if (inputEl) { inputEl.value = this.state.search; }
		} else {
			this.state.search = undefined;
		}
	}


	constructor (props?: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;
	}


	handleKeydownGuard (e: KeyboardEvent) {
		if (e.key === '@') e.preventDefault();
	}

	async searchOrganizationByMailAsync () {
		if (!this.state.search) {
			this.state.noResultForSearch = false;
			this.state.selectedSearchedOrganization = undefined;
			return;
		} else {
			try {
				this._modal?._loader()?.show(`Recherche de l'organisation...`);
				this.state.noResultForSearch = false;
				const { data } = await OrganizationApi.search({ email: `${this.state.search}${this.organizationMailSuffix}` });
				this.state.selectedSearchedOrganization = data;
			} catch (e: any) {
				this.state.selectedSearchedOrganization = undefined;
				this.state.noResultForSearch = true;
			} finally {
				this._modal?._loader()?.hide();
			}
		}
	}

	clearSelectedSearchAndSearch () {
		this.state.search = undefined;
		this.state.selectedSearchedOrganization = undefined;
	}

	async sendAskFusionAsync () {
		if (this.state.search && !this.state.search.length) {
			useNotif.warning(
				`Champ incomplet`,
				`Veuillez renseigner une adresse mail valide`,
			);
			return;
		} else {
			await OrganizationFusionRequestApi.add({ organizationTargetEmail: `${this.state.search}${this.organizationMailSuffix}` });
			useNotif.success(
				`Demande de fusion envoyée`,
				`La demande de fusion à l'organisation ${this.state.search} a bien été envoyée`,
			);
			// this.$root.$emit('askFusion');
			this._modal?.close();
		}
	}
}
